import type { FaireProductEntity } from "../../entity_types/product";

export const p_4n6uvfzpqq: FaireProductEntity = {
  token: "p_4n6uvfzpqq",
  type: "product",
  name: "Tahitian Pearl Hoop Earring",
  brandName: "Leighton Lam Designs",
  imageUrl:
    "https://cdn.faire.com/fastly/a1e95082b45a861fda4c7bdc6930a708afa879fda4ce9b773ffd1a4df6241975.jpeg",
  priceDollars: 30,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/88d4fa12ece1544ac211645fa3534f88e47872bdbdd7891f26c42e49f0d676fc.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
